"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireDefault(require("react"));

var _coreDecorators = require("core-decorators");

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = _interopRequireDefault(require("./styles"));

var _Expandable = _interopRequireDefault(require("../../../Expandable"));

var _Item = require("../Item");

var _SelectedItem = require("../SelectedItem");

var _SearchInput = _interopRequireDefault(require("../../../Input/SearchInput"));

var _class, _temp;

var Group = (_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Group, _React$Component);

  function Group() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Group);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Group)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      expanded: false,
      searchText: ''
    });
    return _this;
  }

  (0, _createClass2.default)(Group, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          group = _this$props.group,
          selectedKeysSet = _this$props.selectedKeysSet,
          theme = _this$props.theme,
          withSearch = _this$props.withSearch,
          groupClassName = _this$props.groupClassName,
          controlledSelectedItems = _this$props.controlledSelectedItems,
          groupSelectedItems = _this$props.groupSelectedItems;
      var expanded = this.state.expanded;
      var items = getItems(group.items, selectedKeysSet);
      var selectedItems;

      if (controlledSelectedItems) {
        selectedItems = groupSelectedItems;
      } else {
        selectedItems = getSelectedItems(group.items, selectedKeysSet);
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_styles.default.root(theme), groupClassName)
      }, renderHeader(group.title, expanded, this.headerClickHandler, theme), selectedItems.length !== 0 && renderSelectedItems(selectedItems, this.selectedItemClickHandler, theme), expanded && withSearch && _react.default.createElement(_SearchInput.default, {
        type: "small",
        onChange: this.handleItemSearch
      }), renderItems((items.length !== 0 || controlledSelectedItems) && expanded, items, this.itemClickHandler, this.state.searchText, theme));
    }
  }, {
    key: "handleItemSearch",
    value: function handleItemSearch(e) {
      this.setState({
        searchText: e.target.value
      });
      this.props.onSearch(e.target.value, this.props.index);
    }
  }, {
    key: "headerClickHandler",
    value: function headerClickHandler() {
      this.setState(function (prevState) {
        return {
          expanded: !prevState.expanded
        };
      });
    }
  }, {
    key: "itemClickHandler",
    value: function itemClickHandler(key, item) {
      this.props.onSelectKey(key, item, this.props.index);
    }
  }, {
    key: "selectedItemClickHandler",
    value: function selectedItemClickHandler(key, item) {
      this.props.onRemoveKey(key, item, this.props.index);
    }
  }]);
  return Group;
}(_react.default.Component), _temp), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "handleItemSearch", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleItemSearch"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "headerClickHandler", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "headerClickHandler"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itemClickHandler", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "itemClickHandler"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedItemClickHandler", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "selectedItemClickHandler"), _class.prototype)), _class);
exports.Group = Group;

function renderHeader(title, expanded, clickHandler, theme) {
  return _react.default.createElement("div", {
    className: _styles.default.header,
    role: "presentation",
    onClick: clickHandler
  }, _react.default.createElement("div", {
    className: _styles.default.title
  }, title), _react.default.createElement("div", {
    className: _styles.default.toggleIcon()
  }, _react.default.createElement("div", {
    className: _styles.default.toggleHorizontal(theme, expanded)
  }), _react.default.createElement("div", {
    className: _styles.default.toggleVertical(theme, expanded)
  })));
}

function renderSelectedItems(items, itemClickHandler, theme) {
  return _react.default.createElement("div", {
    className: _styles.default.selectedItems
  }, items.map(function (i) {
    return _react.default.createElement(_SelectedItem.SelectedItem, {
      id: i.key,
      title: i.title,
      key: i.key,
      item: i,
      theme: theme,
      onClick: itemClickHandler
    });
  }));
}

function renderItems(visible, items, itemClickHandler, searchText, theme) {
  var filteredItems = items.filter(function (item) {
    if (item.title.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }

    return false;
  });
  return _react.default.createElement(_Expandable.default, {
    visible: visible
  }, _react.default.createElement("div", {
    className: _styles.default.items(theme)
  }, filteredItems.length === 0 && _react.default.createElement("div", null, "No results found"), filteredItems.length > 0 && filteredItems.map(function (i) {
    return _react.default.createElement(_Item.Item, {
      id: i.key,
      title: i.title,
      count: i.count,
      key: i.key,
      item: i,
      theme: theme,
      onClick: itemClickHandler
    });
  })));
}

function getItems(items, selectedKeysSet) {
  return items.filter(function (i) {
    return !selectedKeysSet.has(i.key);
  });
}

function getSelectedItems(items, selectedKeysSet) {
  return items.filter(function (i) {
    return selectedKeysSet.has(i.key);
  }).slice();
}